import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SiteHeader } from 'src/components/ui/SiteHeader';
import { useAsset } from 'src/context-providers/AssetContext';
import { Routes } from 'src/router/Routes';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import { isNullUndefinedOrEmpty } from 'src/util/utils';
import { Formik } from 'formik';
import { withZodSchema } from 'formik-validator-zod';
import { ApprovableRealEstateAsset } from '@brickwise/asset-validation/dist/schema/realEstateAsset';
import { getDefaultData } from '@brickwise/asset-validation/dist/utils';
import { AssetApprovalLocation } from 'src/components/assets/asset-approval/AssetApprovalLocation';
import { merge } from 'lodash';
import { AssetApprovalPropertyDetails } from 'src/components/assets/asset-approval/AssetApprovalPropertyDetails';
import { AssetApprovalRentalDetails } from 'src/components/assets/asset-approval/AssetApprovalRentalDetails';
import { AssetApprovalInvestmentDetails } from 'src/components/assets/asset-approval/AssetApprovalInvestmentDetails';
import { AssetApprovalDescriptions } from 'src/components/assets/asset-approval/AssetApprovalDescriptions';
import { AssetApprovalImages } from 'src/components/assets/asset-approval/AssetApprovalImages';
import { AssetApprovalDocuments } from 'src/components/assets/asset-approval/AssetApprovalDocuments';

export const AssetApprovalPage: FC = () => {
  const { asset } = useAsset();
  const { t } = useTranslation();

  return (
    <div>
      <SiteHeader
        breadcrumbs={[
          {
            link: Routes.ASSETS.ROOT,
            label: t('dashboard.breadcrumbs.assets'),
            icon: <ApartmentOutlinedIcon sx={{ mr: 0.5 }} fontSize="inherit" />,
          },
          {
            link: Routes.ASSETS.APPROVAL.replace(':assetId', asset.id),
            label: isNullUndefinedOrEmpty(asset.descriptions?.title) ? asset.id : (asset.descriptions.title as string),
          },
        ]}
        headline={'Asset Approval for ' + (isNullUndefinedOrEmpty(asset.descriptions?.title) ? asset.id : asset.descriptions?.title)}
      ></SiteHeader>
      <Formik
        initialValues={merge(getDefaultData(ApprovableRealEstateAsset), asset)}
        validate={withZodSchema(ApprovableRealEstateAsset)}
        onSubmit={() => {
          return;
        }}
      >
        {(props) => {
          return (
            <form onSubmit={props.handleSubmit}>
              <AssetApprovalLocation />
              <AssetApprovalPropertyDetails />
              <AssetApprovalRentalDetails />
              <AssetApprovalInvestmentDetails />
              <AssetApprovalDescriptions />
              <AssetApprovalImages />
              <AssetApprovalDocuments />
            </form>
          );
        }}
      </Formik>
    </div>
  );
};
